import { useEffect, useMemo, useState } from "react";
import { buildInlineFilterQuery } from "../utils/allPolicyHelpers";

const useAllPolicyFilters = (viewMode = "trips") => {
  const [statusFilter, setStatusFilter] = useState("");
  const [tripStatusFilter, setTripStatusFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);

  useEffect(() => {
    setTripStatusFilter("");
  }, [viewMode]);

  const additionalFilterQuery = useMemo(
    () =>
      buildInlineFilterQuery({
        status: statusFilter,
        tripStatus: tripStatusFilter,
        coverType: typeFilter,
        dateRange,
      }),
    [statusFilter, tripStatusFilter, typeFilter, dateRange]
  );

  const clearDates = () => setDateRange([null, null]);

  return {
    statusFilter,
    setStatusFilter,
    tripStatusFilter,
    setTripStatusFilter,
    typeFilter,
    setTypeFilter,
    dateRange,
    setDateRange,
    clearDates,
    additionalFilterQuery,
  };
};

export default useAllPolicyFilters;
